import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingCardExpired = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="240"
        height="184"
        viewBox="0 0 240 184"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M169.287 1.15955C197.325 5.13453 232.503 20.234 238.891 42.4761C245.282 64.7762 222.896 94.1645 201.586 117.677C180.283 141.244 160.075 158.939 135.318 170.861C110.564 182.731 81.3143 188.913 61.6275 177.717C41.9951 166.6 31.9934 138.134 20.3447 113.065C8.65851 87.9414 -4.69858 66.1591 1.62774 50.8893C7.96769 35.6775 33.9911 26.9748 53.5656 21.5011C73.1401 16.0274 86.2079 13.7214 103.251 9.05501C120.235 4.32727 141.192 -2.81542 169.287 1.15955Z"
          fill="#F9F9F9"
        />
        <rect
          x="58.4038"
          y="45.8"
          width="137.344"
          height="94.4242"
          rx="12"
          fill="#B2B2B2"
        />
        <rect
          x="58.3999"
          y="65.5392"
          width="137.344"
          height="15.4512"
          fill="#F9F9F9"
        />
        <rect
          x="79.002"
          y="95.3444"
          width="48.0705"
          height="6.00881"
          rx="3.00441"
          fill="#F9F9F9"
        />
        <path
          d="M187 156C202.464 156 215 143.464 215 128C215 112.536 202.464 100 187 100C171.536 100 159 112.536 159 128C159 143.464 171.536 156 187 156Z"
          fill="#ED9F38"
        />
        <path
          d="M187 148C189.209 148 191 146.209 191 144C191 141.791 189.209 140 187 140C184.791 140 183 141.791 183 144C183 146.209 184.791 148 187 148Z"
          fill="#F2F7FF"
        />
        <path
          d="M187 109L187 136.5"
          stroke="#F2F7FF"
          strokeWidth="8"
          strokeMiterlimit="10"
        />
      </svg>
    );
  }
);
export default BillingCardExpired;
